module.exports = function() {
  return new Worker(__webpack_public_path__ + "096105a931737be38f06.worker.js");
};